<div [@slideInOut]="active ? 'show' : 'hide'" class="legend-animate-container">
    <!-- <div class="no-legend-wrapper" >       
        {{ 'legendTxt.soon-available' | translate }}
    </div> -->
    
        <div [@.disabled]="disableAnimation()">
           
        <mat-accordion multi="false">

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.RoadAndPath"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>                
                    <img src='./assets/legend/Img25k/leg1_25k_{{translateService.currentLang.slice(0, -1)}}.png'
                        alt='{{"legend.RoadAndPath"|translate}}' >
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.RailNetwork"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img25k/leg2_25k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.RailNetwork"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.Hydrography"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img25k/leg3_25k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.Hydrography"|translate}}' />
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.Buildings"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img25k/leg4_25k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.Buildings"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.Constructions"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img25k/leg5_25k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.Constructions"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.Groundcover"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img25k/leg6_25k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.Groundcover"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.Relief"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img25k/leg7_25k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.Relief"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header class="legendThemeTitle">
                    <mat-panel-title>
                        {{"legend.AdministrativeData"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img25k/leg8_25k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.AdministrativeData"|translate}}'>
                </div>
            </mat-expansion-panel>

      

        </mat-accordion> 
    
  
    </div>
 
</div>
